import { render, staticRenderFns } from "./SimpleNegotiation.vue?vue&type=template&id=a77ee246&"
import script from "./SimpleNegotiation.vue?vue&type=script&lang=js&"
export * from "./SimpleNegotiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports